<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="message-box" v-show="isShowMessageBox">
    <div class="mask" @click="cancel"></div>
    <div class="message-content">
      <div class="close-icon" @click="cancel">
        <svg-icon name="closed" ></svg-icon>
      </div>
      <svg-icon v-if="type==='remind'" class="type-icon" name="remind"></svg-icon>
      <svg-icon v-if="type==='success'" class="type-icon success" name="success"></svg-icon>
      <div class="title" v-if="title">{{ title }}</div>
      <div class="content" v-if="content">{{ content }}<span class="linked" v-if="linked" @click="jumpPage">{{linked.name}}</span></div>
      <div class="input-container" v-if="isShowInput">
        <input type="text" v-model="inputValue"  ref="input" @keyup.enter="confirm">
      </div>
      <div class="text-list" v-show="textList.length">
        <div class="text-item" v-for="item,index in textList" :key="index" >
          <span  >{{ item.name }}</span>
          <span >{{ item.value }}</span>
        </div>
        <button v-if="textListButton" @click="confirm" class="text-list-button">{{textListButton}}</button>
      </div>
      <div class="button-list">
        <div v-for="item,index in buttonList" :key="index" >
          <button 
            :class="[item.class]" @click="() => confirmButtonList(item)">{{ item.name }}</button>
        </div>
      </div>
      <div class="btn-group">
        <button class="btn-default" @click="cancel" v-show="isShowCancelBtn">{{ cancelBtnText }}</button>
        <button class="btn-primary btn-confirm" @click="confirm" v-show="isShowConfimrBtn">{{ confirmBtnText }}</button>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      isShowInput: {
        type: Boolean,
        default: false
      },
      inputValue: {
        type: String,
        default: ''
      },
      isShowCancelBtn: {
        type: Boolean,
        default: false
      },
      isShowConfimrBtn: {
        type: Boolean,
        default: false
      },
      cancelBtnText: {
        type: String,
        default: '取消'
      },
      confirmBtnText: {
        type: String,
        default: '确定'
      },
      linked: {
        type: Object,
        default: null
      },
      buttonList: {
        type: Array,
        default: () => []
      },
      textList: {
        type: Array,
        default: () => []
      },
      textListButton: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        isShowMessageBox: false,
        resolve: '',
        reject: '',
        promise: '' // 保存promise对象
      };
    },
    methods: {
      confirmButtonList (item) {
        this.isShowMessageBox = false;
        this.resolve(item.type);
        this.remove();
      },
      jumpPage () {
        this.isShowMessageBox = false;
        this.resolve(this.linked.url);
        this.remove();
      },
      // 确定,将promise断定为resolve状态
      confirm () {
        if (this.isShowInput && !this.inputValue) {
          this.$toast('请输入作品名称')
          return
        } 
        this.isShowMessageBox = false;
        if (this.isShowInput) {
          this.resolve(this.inputValue);
        } else {
          this.resolve('confirm');
        }
        this.remove();
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        this.reject('cancel');
        this.remove();
      },
      // 弹出messageBox,并创建promise对象
      showMsgBox: function () {
        this.isShowMessageBox = true;
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
        // 返回promise对象
        return this.promise;
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      }
    }
  };
</script>
 
<style lang="scss" scoped>
  .message-box {
    position: relative;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 999;
      background: rgba(0, 0, 0, 0.5);
    }
    .message-content {
      position: fixed;
      box-sizing: border-box;
      width: 460px;
      height: 270px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #FFFFFF;
      box-shadow: 10px 10px 9px 0px rgba(85, 85, 85, 0.5);
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      z-index: 999;
      text-align: center;
      font-size: 16px;
      color: #555555;
      line-height: 28px;
      box-sizing: border-box;
      padding: 34px 70px;
      .type-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 12px;
        &.success {
          margin: 60px 0 40px;
        }
      }
      .close-icon {
        position: absolute;
        right: 10px;
        top: 6px;
        cursor: pointer;
        .svg-icon {
          width: 16px;
          height: 16px;
        }
      }
      .input-container {
        margin-top: 34px;
      }
      input {
        border-radius: 4px;
        border: 1px solid #2d8cf0;
        box-sizing: border-box;
        height: 40px;
        width: 100%;
        display: inline-block;
        font-size: 14px;
        line-height: 1;
        color: #999999;
        padding: 10px 15px;
        outline: none;
        &:focus {
          border-color: #2d8cf0;
        }
      }
      .linked {
        cursor: pointer;
        color: #2d8cf0;
        text-decoration: underline;
      }
      .btn-group {
        font-size: 16px;
        display: flex;
        justify-content: space-around;
        position: absolute;
        bottom: 20px;
        width: 100%;
        left: 0;
        .btn-default {
          width: 100px;
          height: 40px;
          background: #FBFBFB;
          border-radius: 4px;
          border: 1px solid #EEEEEE;
          color: #999999;
          &:hover {
            opacity: .8;
          }
        }
 
        .btn-primary {
          width: 100px;
          height: 40px;
          background: #4E6EFF;
          border-radius: 4px;
          color: #FFFFFF;
          &:hover {
            opacity: .8;
          }
        }
      }
      .text-list {
        width: 100%;
        margin-top: 12px;
        .text-item {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        .text-list-button {
          margin-top: 30px;
          width: 330px;
          height: 40px;
          background: #4E6EFF;
          border-radius: 4px;
          color: #FFFFFF;
        }
      }
      .button-list {
        button {
          width: 200px;
          height: 40px;
          border-radius: 4px;
          font-size: 16px;
          color: #FFFFFF;
          margin-top: 30px;
          &.button-error {
            background: #F95E5E;
          }
          &.button-primary {
            background: #2d8cf0;
          }
        }
      }
    }
  }
</style>